import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { BrowseAllContentCTABase } from "./styles";

const BrowseAllContentCTA = ({ href, contentType, contentCount }) => {
    if (contentCount === 0) return null;

    const history = useHistory();

    const goToBrowsePage = () => history.push(href);

    const text =
        contentCount === 1
            ? `View 1 ${contentType}`
            : `View all ${contentCount} ${contentType}s`;

    return (
        <BrowseAllContentCTABase onClick={goToBrowsePage}>
            {text}
        </BrowseAllContentCTABase>
    );
};

BrowseAllContentCTA.propTypes = {
    contentCount: PropTypes.number.isRequired,
    contentType: PropTypes.oneOf(["icon", "photo", "collection"]).isRequired,
    href: PropTypes.string.isRequired
};

export default BrowseAllContentCTA;
